import { SVGProps } from 'react';

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 1.625C6.20711 1.625 6.375 1.79289 6.375 2L6.375 10.0947L9.48483 6.98484C9.63128 6.83839 9.86872 6.83839 10.0152 6.98484C10.1616 7.13128 10.1616 7.36872 10.0152 7.51516L6.26516 11.2652C6.11872 11.4116 5.88128 11.4116 5.73484 11.2652L1.98483 7.51517C1.83839 7.36872 1.83839 7.13128 1.98483 6.98484C2.13128 6.83839 2.36872 6.83839 2.51517 6.98484L5.625 10.0947L5.625 2C5.625 1.79289 5.79289 1.625 6 1.625Z'
    />
  </svg>
);
